import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Button } from "@progress/kendo-react-buttons";
import LoadingPanel from "../common/LoadingPanel";
import NeexpedovaneBalikyGrid from "./Paleta/NeexpedovaneBalikyGrid";
import BalikyNaPaleteGrid from "./Paleta/BalikyNaPaleteGrid";
import { dateConvert } from "../common/Helpers";
import { paletaController } from "../../controllers/paleta.controller";
import { firstBy, thenBy } from "thenby";
import confirmService from "../common/confirmService";

class PaletaDialogContent extends Component {
    state = {
        loading: false,
        errorMessage: null,
        vymazatPaletu: false,
        selectedPaletaId: null,
        neexpedovaneBaliky: [],
        balikyPaleta: [],
        isUpdateRequest: false,
        typRazeni: null,
        pocetBalikuNaPalete: 0,
        pocetNeexpedovanychBaliku: 0,
        pdfLoading: false,
        pdfPrint: true,
        pdfFile: null
    };

    componentDidMount() {
        this.getNeexpedovaneBaliky(this.props.idPaleta);
    }

    getNeexpedovaneBaliky(idPaleta) {
        paletaController.GetNeexpedovaneBaliky(idPaleta).then((response) => {
            let data = JSON.parse(JSON.stringify(response), dateConvert);
            if (data.errorMessage != null) {
                this.setState({ errorMessage: data.errorMessage });
            } else {
                var balikyItems = data.filter((item) => !item.naPalete);

                var paletaItems = data.reduce(function (filtered, item) {
                    if (item.naPalete) {
                        item.naPalete = false;
                        filtered.push(item);
                    }
                    return filtered;
                }, []);
                this.setState({
                    neexpedovaneBaliky: balikyItems,
                    balikyPaleta: paletaItems,
                    loading: false,
                    pocetNeexpedovanychBaliku: balikyItems.length,
                    pocetBalikuNaPalete: paletaItems.length,
                    selectedPaletaId: idPaleta
                });
            }
        });
    }

    handleButtonClick = (event) => {
        event.preventDefault();
        this.setState({
            lastButtonEvent: event.currentTarget.id,
            isUpdateRequest: true
        });
    };

    getSelectedNeexpedovaneBaliky = async (items) => {
        if (this.state.lastButtonEvent === "add") {
            var neexpedovaneBaliky = items.filter((item) => !item.naPalete);
            //if (neexpedovaneBaliky.length > 0) {
            var newBalikyPaleta = items.reduce(function (filtered, item) {
                if (item.naPalete) {
                    item.naPalete = false;
                    filtered.push(item);
                }
                return filtered;
            }, []);

            var balikyPaleta = this.state.balikyPaleta.concat(newBalikyPaleta);

            this.setState({
                pocetBalikuNaPalete: balikyPaleta.length,
                pocetNeexpedovanychBaliku: neexpedovaneBaliky.length,
                neexpedovaneBaliky: neexpedovaneBaliky,
                balikyPaleta: balikyPaleta,
                isUpdateRequest: false
            });
            // } else {
            //     var localizationService = provideLocalizationService(this);
            //     await confirmService.show({
            //         message: localizationService.toLanguageString(
            //             "PaletyFRM.Vyberte jeden alebo viac neexpedovaných balíkov !",
            //             "Vyberte jeden alebo viac neexpedovaných balíkov !"
            //         )
            //     });
            // }
        }
    };

    getSelectedPaletaBaliky = async (items) => {
        if (this.state.lastButtonEvent === "remove") {
            var newBalikyPaleta = items.filter((item) => !item.naPalete);
            // if (newBalikyPaleta.length > 0) {
            var neexpedovaneBaliky = items.reduce(function (filtered, item) {
                if (item.naPalete) {
                    item.naPalete = false;
                    filtered.push(item);
                }
                return filtered;
            }, []);

            var newNeexpedovaneBaliky = this.state.neexpedovaneBaliky.concat(neexpedovaneBaliky);

            this.setState({
                pocetBalikuNaPalete: newBalikyPaleta.length,
                pocetNeexpedovanychBaliku: newNeexpedovaneBaliky.length,
                neexpedovaneBaliky: newNeexpedovaneBaliky,
                balikyPaleta: newBalikyPaleta,
                isUpdateRequest: false
            });
            // } else {
            //     var localizationService = provideLocalizationService(this);
            //     await confirmService.show({
            //         message: localizationService.toLanguageString(
            //             "PaletyFRM.Vyberte jeden alebo viac balíkov na palete !",
            //             "Vyberte jeden alebo viac balíkov na palete !"
            //         )
            //     });
            // }
        }
    };

    handleChangeRazeni = (event) => {
        event.preventDefault();
        var sortedPaleta = this.state.balikyPaleta;
        var sortedBaliky = this.state.neexpedovaneBaliky;
        var typRazeni = event.target.value;
        switch (typRazeni) {
            case "1":
                sortedPaleta = this.state.balikyPaleta.sort(firstBy("skratka", { ignoreCase: true }).thenBy("carovyKod"));
                var sortedBaliky = this.state.neexpedovaneBaliky.sort(firstBy("skratka", { ignoreCase: true }).thenBy("carovyKod"));
                break;
            case "2":
                sortedPaleta = this.state.balikyPaleta.sort(firstBy("typTovaru", { ignoreCase: true }).thenBy("idVlna").thenBy("carovyKod"));
                var sortedBaliky = this.state.neexpedovaneBaliky.sort(firstBy("typTovaru", { ignoreCase: true }).thenBy("idVlna").thenBy("carovyKod"));
                break;
            case "3":
                sortedPaleta = this.state.balikyPaleta.sort(firstBy("pocetKusu", { direction: -1 }).thenBy("carovyKod"));
                var sortedBaliky = this.state.neexpedovaneBaliky.sort(firstBy("pocetKusu", { direction: -1 }).thenBy("carovyKod"));
                break;
            case "4":
                sortedPaleta = this.state.balikyPaleta.sort(firstBy("datum").thenBy("carovyKod"));
                var sortedBaliky = this.state.neexpedovaneBaliky.sort(firstBy("datum").thenBy("carovyKod"));
                break;
            case "5":
                sortedPaleta = this.state.balikyPaleta.sort(firstBy("skenovalUzivatelJmeno", { ignoreCase: true }).thenBy("carovyKod"));
                var sortedBaliky = this.state.neexpedovaneBaliky.sort(firstBy("skenovalUzivatelJmeno", { ignoreCase: true }).thenBy("carovyKod"));
                break;
            default:
                sortedPaleta = this.state.balikyPaleta.sort(firstBy("carovyKod"));
                var sortedBaliky = this.state.neexpedovaneBaliky.sort(firstBy("carovyKod"));
                break;
        }

        this.setState({ typRazeni: typRazeni, neexpedovaneBaliky: sortedBaliky, balikyPaleta: sortedPaleta });
    };

    handeVymazatPaletuClick = (event) => {
        event.preventDefault();
        var balikyPaleta = this.state.balikyPaleta.map((item) => {
            item.naPalete = false;
            return item;
        });
        var neexpedovaneBaliky = this.state.neexpedovaneBaliky.concat(balikyPaleta);
        this.setState({
            neexpedovaneBaliky: neexpedovaneBaliky,
            balikyPaleta: [],
            pocetBalikuNaPalete: 0,
            pocetNeexpedovanychBaliku: neexpedovaneBaliky.length
        });
    };

    handePaletaSaveClick = (event) => {
        event.preventDefault();
        var button = event.target;
        button.disabled = true;
        var balikyNaPalete = this.state.balikyPaleta.map((item) => {
            item.naPalete = true;
            return item;
        });
        paletaController.SavePaleta(this.state.selectedPaletaId, balikyNaPalete).then(async (response) => {
            if (response.errorMessage) {
                button.disabled = false;
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage
                });
            } else {
                this.props.toggleDialog();
                this.props.reloadGrid(() => {
                    if (response.paletaId > 0) {
                        this.props.printPaletaList(response.paletaId);
                        setTimeout(this.props.selectSavedBalikPaleta(response.paletaId), 500);
                    }
                });
            }
        });
    };

    renderDialogContent() {
        var localizationService = provideLocalizationService(this);
        return (
            <div id="PaletaDialogContent">
                <div>
                    <div className="col-lg-6">
                        <h2>
                            <span>{localizationService.toLanguageString("PaletyFRM.NEEXPEDOVANÉ BALÍKY", "NEEXPEDOVANÉ BALÍKY")}</span> (
                            {this.state.pocetNeexpedovanychBaliku})
                        </h2>
                        <NeexpedovaneBalikyGrid
                            items={this.state.neexpedovaneBaliky}
                            getSelectedNeexpedovaneBaliky={this.getSelectedNeexpedovaneBaliky}
                            isUpdateRequest={this.state.isUpdateRequest}
                        />
                    </div>

                    <div className="col col-lg-1 align-items-center">
                        <div id="PaletaButtonContainer" className="text-center">
                            <button className="k-button k-button-icontext font-bold" id="add" onClick={this.handleButtonClick}>
                                <i role="presentation" className="fa fa-arrow-right fa-lg"></i>
                            </button>

                            <button className="k-button k-button-icontext font-bold" id="remove" onClick={this.handleButtonClick}>
                                <i role="presentation" className="fa fa-arrow-left fa-lg"></i>
                            </button>
                        </div>
                    </div>

                    <div className="col-lg-5">
                        <h2>
                            <span>{localizationService.toLanguageString("PaletyFRM.BALÍKY NA PALETE", "BALÍKY NA PALETE")}</span> (
                            {this.state.pocetBalikuNaPalete})
                        </h2>
                        <BalikyNaPaleteGrid
                            items={this.state.balikyPaleta}
                            getSelectedPaletaBaliky={this.getSelectedPaletaBaliky}
                            isUpdateRequest={this.state.isUpdateRequest}
                        />
                    </div>
                </div>
                <div>
                    <div className="col-lg-6">
                        <div className="grid-button-bar">
                            <div className="col-xs-12 text-right">
                                <label htmlFor="typRazeni">{localizationService.toLanguageString("PaletyFRM.Radenie balíkov", "Radenie balíkov")}</label>
                                <select id="typRazeni" className="form-control w-150" onChange={this.handleChangeRazeni} defaultValue={this.state.typRazeni}>
                                    <option value="0">{localizationService.toLanguageString("PaletyFRM.Podľa čísla balíka", "Podľa čísla balíka")}</option>
                                    <option value="1">{localizationService.toLanguageString("PaletyFRM.Podľa príjemcu", "Podľa príjemcu")}</option>
                                    <option value="2">{localizationService.toLanguageString("PaletyFRM.Podľa typu tovaru", "Podľa typu tovaru")}</option>
                                    <option value="3">{localizationService.toLanguageString("PaletyFRM.Podľa počtu ks", "Podľa počtu ks")}</option>
                                    <option value="4">
                                        {localizationService.toLanguageString("PaletyFRM.Podľa dátumu vytvorenia", "Podľa dátumu vytvorenia")}{" "}
                                    </option>
                                    <option value="5">{localizationService.toLanguageString("PaletyFRM.Podľa užívateľa", "Podľa užívateľa")}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1"></div>
                    <div className="col-lg-5">
                        <div className="grid-button-bar">
                            <div className="col-sm-6">
                                <Button icon="delete" className="font-bold" onClick={this.handeVymazatPaletuClick}>
                                    {localizationService.toLanguageString("PaletyFRM.Vymazať paletu", "Vymazať paletu")}
                                </Button>
                            </div>
                            <div className="col-sm-6 text-right">
                                <Button icon="save" className="font-bold auto-focus" onClick={this.handePaletaSaveClick}>
                                    {localizationService.toLanguageString("PaletyFRM.Uložiť", "Uložiť")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();
        contents = this.state.errorMessage == null ? contents : <div className="alert alert-danger">{this.state.errorMessage}</div>;
        return <div>{contents}</div>;
    }
}

export default PaletaDialogContent;
registerForLocalization(PaletaDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/PaletaDialogContent.js